import { render, staticRenderFns } from "./AboutInfo.vue?vue&type=template&id=567dcd90"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"
import style0 from "./AboutInfo.vue?vue&type=style&index=0&id=567dcd90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports